import React from 'react';
import {connect} from 'react-redux';
import compose from 'recompose/compose';
import lifecycle from "recompose/lifecycle";
import {Form, Grid, Label} from "semantic-ui-react";
import {FormattedMessage} from "react-intl";
import {addBreakTagAction, searchBreakTagsAction, Types as ActionTypes} from "../../../pages/EditBreak/actions";
import {addBreakSiteTagAction} from "../../../pages/EditBreak/actions";
import Button from "semantic-ui-react/dist/commonjs/elements/Button";
import Icon from "semantic-ui-react/dist/commonjs/elements/Icon";
import {startEditBreakSiteTagAction} from "../../../pages/EditBreak/BreakTagModal/actions";
import FieldStatusIcon from "../FieldStatusIcon";
import {getAllResourcesAction} from "../../../resources/actions";
import * as ResourceApi from "../../../api/resources";
import {filterOptionsFactory, sortOptionsFactory} from "../../../viewOptions/factories";
import Dropdown from "semantic-ui-react/dist/commonjs/modules/Dropdown";
import {getUserResourceActions} from "../../../pages/Profile/selectors";
import {includes, isNoU, SupportedLangs} from "../../../utils/DBUtils";
import {startDeleteBreakTagAction} from "../../../pages/EditBreak/DeleteBreakTagModal/actions";

const getBreakTagActions = getUserResourceActions(ResourceApi.Types.BreakTag);

const makeTagWithText = (text) => ({
    label: text.toLowerCase().trim().replace(/ /g, "-"),
    translations: {
        "en-US": text
    }
});

const BreakSiteTagEditorView = (props) => {
    return (
        <div className={`auto-save-field`}>
            <Form>
                <Grid columns="equal">
                    <Grid.Row className="db-field-label-row">
                        <Label basic className="db-field-label">
                            <FormattedMessage id={props.labelKey}/>
                        </Label>
                        <FieldStatusIcon
                            error={null}
                            saved={props.savedField}
                            show={true}
                            isSaving={props.isSaving}/>
                    </Grid.Row>
                    <Grid.Row>
                        <p>Tag count: {props.tags.length}/10</p>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column>
                            <Dropdown placeholder='Search Tags'
                                      className="full-width"
                                      fluid
                                      search
                                      multiple
                                      selection
                                      searchQuery={props.searchText}
                                      onSearchChange={(e, data) => {
                                          props.search(data.searchQuery);
                                      }}
                                      onLabelClick={(e, data) => {
                                          props.editTag(props.loadedTags.find((tag) => tag.id === data.value));
                                      }}
                                      renderLabel={(item, index, options) => {
                                          return (
                                              <Label key={options.key} as="a" color="blue"
                                                     onClick={(e) => options.onClick(e, options)}>
                                                  {item.text}
                                                  {props.removalAllowed ? <Icon name='delete'
                                                                                onClick={(e) => options.onRemove(e, options)}/> : ""}
                                              </Label>
                                          )
                                      }}
                                      onChange={(val1, val2) => {
                                          let tags = val2.value;
                                          // if new size is larger than current, we're adding
                                          // prevent if at max tags
                                          // or if no tags
                                          if (tags.length > 10 || tags.length === 0) {
                                              return;
                                          }

                                          props.onValueChanged(tags);
                                      }}
                                      value={props.tags}
                                      options={props.loadedTags.map((tag) => {
                                        // console.log(`tag`, tag)  
                                        let text = tag.translations[props.lang];
                                          if (isNoU(text) || text.trim() === "") {
                                              // find first text that exists
                                              for (let lang of SupportedLangs) {
                                                  text = tag.translations[lang];
                                                  if (!isNoU(text) && text.trim() !== "") {
                                                      break;
                                                  }
                                              }
                                          }

                                          return {
                                              value: tag.label,
                                              text: text,
                                              key: tag.id,
                                              color: "blue"
                                          };
                                      })}/>
                        </Grid.Column>
                        <Grid.Column>
                            {props.canCreate ? (
                                <Button onClick={() => props.createAdd(makeTagWithText(props.searchText))}
                                        primary
                                        disabled={props.searchText.length === 0 || !props.addingAllowed}>
                                    Create/Add
                                </Button>
                            ) : ""}
                            {props.canDelete ? (
                                <Button onClick={() => props.startDeleteTag()}
                                        danger>
                                    Delete
                                </Button>
                            ) : ""}
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Form>
        </div>
    );
};

const mapState = (state, ownProps) => {
    console.log(`BreakSiteTagEditor state`, state)
    console.log(`BreakSiteTagEditor ownProps`, ownProps)
    console.log(`currentResource`, ownProps.formProxy.currentResource)
    const {editBreak, resources} = state;
    let searchText = editBreak.breakTagSearchText;
    let breakTagActions = getBreakTagActions(state);

    let canCreate = includes(breakTagActions, "CREATE");
    let canDelete = includes(breakTagActions, "DELETE");

    let brk = resources.resources[editBreak.break.MASTER];
    let tags = ownProps.defaultValue || [];

    let addingTag = editBreak.addingTagCount > 0;

    let loadedTags = Object.keys(resources.resources)
        // get only BreakTag resources
        .filter((key) => {
            return resources.resources[key].resourceId.type === ResourceApi.Types.BreakTag
        })
        // map to value
        .map((key) => resources.resources[key]);

    return {
        lang: brk.lang,
        searchText,
        tags, 
        loadedTags,
        canCreate,
        canDelete,
        isSaving: addingTag,
        savedField: false,
        removalAllowed: tags.length > 1,
        addingAllowed: tags.length < 10
    }
};

const mapDispatch = (dispatch) => {
    return {
        search: (text) => dispatch(searchBreakTagsAction(text)),
        createAdd: (tag) => dispatch(startEditBreakSiteTagAction(tag, {
            postCreateAction: ActionTypes.ADD_BREAK_SITE_TAG
        })),
        addTag: (tagLabels) => {
            console.log(`addTag`, tagLabels)
            dispatch(addBreakSiteTagAction(tagLabels))
        },
        fetchTags: () => dispatch(getAllResourcesAction(ResourceApi.Types.BreakTag, sortOptionsFactory(), filterOptionsFactory())),
        editTag: (tag) => dispatch(startEditBreakSiteTagAction(tag, {})),
        startDeleteTag: () => dispatch(startDeleteBreakTagAction())
    }
};

const BreakSiteTagEditor = compose(
    connect(mapState, mapDispatch),
    lifecycle({
        componentDidMount() {
            if (this.props.loadedTags.length === 0) {
                this.props.fetchTags();
            }
        }
    })
)(BreakSiteTagEditorView);

export default BreakSiteTagEditor;


// WEBPACK FOOTER //
// ./public/components/forms/CustomFields/BreakSiteTagEditor.jsx